<div class="container padding-top-lg report-container">

    <div class="button-panel no-print">
        <a mat-button [routerLink]="['/assessments']" color="primary">
            <mat-icon>chevron_left</mat-icon>
            {{ 'TEAM_DYSFUNCTIONS.BACK_TO_ASSESSMENTS' | translate }}
        </a>
    </div>

    <ng-container *ngxPermissionsOnly="['SuperAdmin', 'Admin', 'Assistant']">
        <app-multi-item-selector mode="ReviewPeriod" (add)="onAdd($event)" (remove)="onRemove($event)" [rpId]="reviewPeriodId" class="no-print" ></app-multi-item-selector>
    </ng-container>

    <app-report-frame 
        [reportTypeName]="'TEAM_DYSFUNCTIONS.STATUS_ASSESSMENT' | translate"
        [reportOptions]="reportOptions"
        [legend]="reportData.legend"
        [showLegend]="true"
        [testval]="testval"
        *ngIf="reportData != null && reportData.barChartDs.datasets">        
        <ng-container slot="table">

            <mat-card class="report-content">
                            
                <mat-card-content>
                    <div class="bar-chart-panel">  
    
                        <div class="chart-title">
                            <h1>{{ 'TEAM_DYSFUNCTIONS.OPERATIONAL_MAP' | translate }}</h1>
                        </div>
    
                        <div class="chart bar-chart">
                            <canvas baseChart #barChart
                                [datasets]="reportData.barChartDs.datasets"
                                [labels]="reportData.barChartDs.labels"
                                [options]="reportData.barChartOptions"
                                [legend]="false"
                                [type]="'bar'">
                            </canvas>
                        </div>      
                    </div>
                    
                </mat-card-content>
            </mat-card>
    
            <div class="margin-area"></div>
    
            <mat-card class="report-content">
                <mat-card-content>
                    <ul class="legend-list">
                        <li><strong>3.0-4.9</strong> {{ 'TEAM_DYSFUNCTIONS.LEGEND_3_4_9' | translate }}</li>
                        <li><strong>5.0-6.9</strong> {{ 'TEAM_DYSFUNCTIONS.LEGEND_5_6_9' | translate }}</li>
                        <li><strong>7.0-9.0</strong> {{ 'TEAM_DYSFUNCTIONS.LEGEND_7_9' | translate }}</li>
                    </ul>
                </mat-card-content>
            </mat-card>
    
            <div class="margin-area"></div>
    
            <mat-card class="report-content">
                <mat-card-content>
                    <!-- freeText -->
                    <div *ngFor="let item of freeTextLists">
                        <app-freetext-panel [freeTexts]="item.list" [subTitle]="item.title" [showSubTitle]="freeTextLists.length > 1" class="no-margin"></app-freetext-panel>
                    </div>
                </mat-card-content>
            </mat-card>
        </ng-container>

               

    </app-report-frame>        

</div>
